const TEST_ENV_LIST = [
  'devops',
  'qa',
  'fe',
  'be',
  'devops2',
  'uat',
  'fe2',
  'be2',
  'qa2',
  'qa3',
  'qa4',
  'qa5',
  'fe3',
  'forlong',
  'sauron',
  'e2e',
  'legolas',
]

const useIsTestEnv = () => {
  const hostname = window.location.hostname ?? ''

  const rawEnv = hostname === 'localhost' ? hostname : hostname.split('.')[0]

  const isTestEnv = rawEnv === 'localhost' || TEST_ENV_LIST.includes(rawEnv)

  return isTestEnv
}

export default useIsTestEnv
